/**
 * @description: 商品套餐列表
 * @author: cyp
 * @update: hwx
 * @update: lyr
 */
<template>
	<div class="commodity-package">
		<ul class="row list-tit" v-show="titShow">
			<!-- <li class="col-md-3"><span class="col-md-10" @click="titClk('1')">商品列表</span></li>
			<li class="col-md-3"><span class="col-md-10" @click="titClk('2')">商品套餐类型</span></li>
			<li class="col-md-3"><span class="col-md-10" @click="titClk('3')">商品口味</span></li> -->
			<li class="col-md-3" v-for="menuItem in menu" :key="menuItem.id"><span class="col-md-10"
					@click="titClk(menuItem.name)">{{menuItem.name}}</span></li>
		</ul>
		<div class="list-con">
			<div class="cpl-list-page" v-show="listShow1">
				<!-- 列表 -->
				<div class="cpl-list" v-show="showList">
					<div class="row row-margin" v-if="list_menu_add">
						<button type="button" class="btn bg-orange btn-flat bigbtn" @click="addCpl">添加商品套餐</button>
						<button type="button" class="btn bg-orange btn-flat bigbtn"><a
								href="https://vodonline.g-hi.com/Download/waresImportTemplate.xls">商品套餐导入模板下载</a></button>
						<button type="button" class="btn bg-orange btn-flat bigbtn" @click="addXlsFun">导入商品套餐</button>
						<input type="file" @change="uploadXls($event)" ref="xlsFile" id="xlsFile">
					</div>
					<div class="row row-margin">
						<label class="list-label-2">门店:</label>
						<div class="col-md-2 ct-col">
							<select class="form-control" ref="cpl_shop" data-placeholder="请选择门店"></select>
						</div>
						<label class="list-label-2">状态:</label>
						<div class="col-md-2 ct-col">
							<select class="form-control" ref="cpl_status">
								<option value="1">启用</option>
								<option value="-1">禁用</option>
							</select>
						</div>
						<label class="list-label-4">推荐套餐:</label>
						<div class="col-md-2 ct-col">
							<select class="form-control" ref="cpl_recommend" data-placeholder="请选择是否推荐套餐">
								<option></option>
								<option value="1">是</option>
								<option value="-1">否</option>
							</select>
						</div>
						<label class="list-label-4">套餐类型:</label>
						<div class="col-md-2 ct-col">
							<select class="form-control" ref="cpl_goodstype" data-placeholder="请选择套餐类型">
								<option value="-1">全部</option>
							</select>
						</div>
					</div>
					<div class="row">
						<label class="list-label-4">套餐名称:</label>
						<div class="col-md-2">
							<input class="form-control" placeholder="请输入套餐名称" v-model.trim="cpl_name">
						</div>
						<div class="pull-right">
							<button type="button" class="btn bg-orange btn-flat btn-middle"
								@click="multiSet">商品套餐批量修改</button>
							<button type="button" class="btn bg-orange btn-flat btn-wide" @click="queryList">查询</button>
						</div>
					</div>
					<div class="table-responsive">
						<table ref="cpl_list" class="table table-bordered table-hover" data-pagination="true"></table>
						<button type="button" class="btn btn-flat btn-middle btn-border-gray"
							@click="backTit">返回</button>
					</div>
				</div>
				<!-- 商品套餐批量修改 -->
				<div class="multi-set-pop ele-hide" ref="multi_set_pop">
					<el-form v-model="multi_set_form" label-width="70px">
						<el-form-item label="门店">
							<el-select v-model="multi_set_form.shop_id" placeholder="请选择门店" popper-class="high-index">
								<el-option v-for="item in shops" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="套餐类型">
							<el-input v-model="multi_set_form.types_str" placeholder="请选择套餐类型" readonly
								@click.native="openPackageTypes">
							</el-input>
						</el-form-item>
						<div class="red-tip">请勾选要编辑的项目</div>
						<div class="row" v-for="(item, index) in multi_config" :key="index">
							<el-checkbox v-model="item.check"></el-checkbox>
							<label
								v-if="item.key==='vip_present_pay' || item.key==='vip_points_pay' || item.key==='included_give_ratio'"
								class="el-form-item__label beyond">{{item.label}}</label>
							<label v-else class="el-form-item__label">{{item.label}}</label>
							<el-select v-if="item.type === 'select' && item.key != 'sales_commission' && item.key !='vip_present_pay'" v-model="item.value"
								:disabled="!item.check" popper-class="high-index">
								<el-option label="是" value="1"></el-option>
								<el-option label="否" value="-1"></el-option>
							</el-select>
							<el-select v-else-if="item.type==='select'&&item.key=='sales_commission'"
								v-model="item.value" :disabled="!item.check" popper-class="high-index">
								<el-option label="计提成计业绩" value="1"></el-option>
								<el-option label="无提成计业绩" value="2"></el-option>
								<el-option label="无提成无业绩" value="3"></el-option>
							</el-select>
							<el-select v-else-if="item.type === 'select' && item.key == 'vip_present_pay'"
								v-model="item.value" :disabled="!item.check" popper-class="high-index">
								<el-option label="仅通用账户可支付" value="-1"></el-option>
								<el-option label="通用账户与赠送账户均可支付" value="1"></el-option>
								<el-option label="仅赠送账户可支付" value="2"></el-option>
								<el-option label="通用账户与赠送账户均不可支付" value="3"></el-option>
							</el-select>
							<el-input v-else :placeholder="item.placeholder" v-model="item.value"
								:disabled="!item.check">
								<template slot="append">{{item.unit}}</template>
							</el-input>
						</div>
					</el-form>
				</div>
				<!-- 商品套餐类型选择弹窗 -->
				<div class="package-type-pop ele-hide" ref="package_type_pop">
					<div class="multi">
						<div class="all">
							<el-checkbox v-model="package_type_all" @change="typesAll">全选</el-checkbox>
						</div>
						<div class="group">
							<el-checkbox-group v-model="multi_set_form.wares_type" @change="typesChange">
								<el-checkbox v-for="item in package_types" :key="item.id"
									:label="item.id">{{item.name}}</el-checkbox>
							</el-checkbox-group>
						</div>
					</div>
				</div>
				<!-- 添加、修改 -->
				<div class="cpl-edit" v-show="showEdit">
					<div class="page-tit">{{edit_tit}}</div>
					<div class="add-code">
						<h2>条码资料</h2>
						<div class="row clearfix">
							<label>条形码</label>
							<div class="col-md-3">
								<input class="form-control" placeholder="输入条形码或用扫描枪扫条形码" v-model.trim="edit_bar_code">
							</div>
						</div>
					</div>
					<div class="list-base clearfix">
						<h2>基础资料</h2>
						<div class="col-md-6">
							<div class="row rowpadding">
								<label>门店</label>
								<div class="col-md-8 ct-col">
									<select class="form-control" ref="edit_shop" data-placeholder="请选择门店">
										<option></option>
									</select>
								</div>
							</div>
							<div class="row rowpadding">
								<label>套餐名称</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="请输入套餐名称" v-model.trim="edit_name">
								</div>
							</div>
							<div class="row rowpadding">
								<label>套餐单位</label>
								<div class="col-md-8 ct-col">
									<select class="form-control" ref="edit_unit" data-placeholder="请选择套餐单位">
										<option></option>
									</select>
								</div>
							</div>
							<div class="row rowpadding">
								<label>套餐类型</label>
								<div class="col-md-8 ct-col">
									<select class="form-control" ref="edit_goodstype"></select>
								</div>
							</div>
							<div class="row rowpadding">
								<label>原价</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="请输入原价" v-model.trim="edit_original_cost" />
								</div>
								<span class="rmarkspan"
									titles="原价是用仅起到显示作用,终端删除线显示:如:原价<span style='text-decoration: line-through;'>200</span>元优惠价150元。</br>推荐使用：系统显示原价(套餐商品的原价合计)"
									@mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
							</div>
							<div class="row rowpadding">
								<label>优惠价</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="请输入套餐优惠价"
										v-model.trim="edit_discount_price">
								</div>
								<span class="rmarkspan"
									titles="优惠价是非会员消费者购买商品后的最后支付价。终端删除线显示如：原价<span style='text-decoration: line-through;'>200</span>优惠价150"
									@mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
							</div>
							<div class="row rowpadding">
								<label>会员价</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="会员价是使用会员卡后享受的价格"
										v-model.trim="edit_vip_price">
								</div>
								<span class="rmarkspan" titles="注册成为会员后享受的价格。场所如果有设置会员打折和会员价的话会同时起作用。"
									@mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
								<p class="edit-vip-hint">会员价设置为0时等于优惠价</p>
							</div>
							<div class="row rowpadding">
								<label>显示顺序</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="请输入显示顺序" v-model.trim="edit_listorder">
								</div>
								<span class="rmarkspan" titles="数字大的优先显示" @mouseenter="hint_language($event, 2)"
									@mouseleave="close_hint_language"></span>
							</div>
						</div>
						<div class="col-md-6">
							<h3>—— 不同会员等级会员价设置 ——</h3>
							<div class="row rowpadding">
								<label>一级会员价</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="填写一级会员等级享受的会员价"
										v-model.trim="vip_level1_price">
								</div>
							</div>
							<div class="row rowpadding">
								<label>二级会员价</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="填写二级会员等级享受的会员价"
										v-model.trim="vip_level2_price">
								</div>
							</div>
							<div class="row rowpadding">
								<label>三级会员价</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="填写三级会员等级享受的会员价"
										v-model.trim="vip_level3_price">
								</div>
							</div>
							<div class="row rowpadding">
								<label>四级会员价</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="填写四级会员等级享受的会员价"
										v-model.trim="vip_level4_price">
								</div>
							</div>
							<div class="row rowpadding">
								<label>五级会员价</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="填写五级会员等级享受的会员价"
										v-model.trim="vip_level5_price">
								</div>
							</div>
							<div class="row rowpadding">
								<label>六级会员价</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="填写六级会员等级享受的会员价"
										v-model.trim="vip_level6_price">
								</div>
							</div>
							<div class="row rowpadding">
								<label>七级会员价</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="填写七级会员等级享受的会员价"
										v-model.trim="vip_level7_price">
								</div>
							</div>
							<div class="row rowpadding">
								<label>八级会员价</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="填写八级会员等级享受的会员价"
										v-model.trim="vip_level8_price">
								</div>
							</div>
							<div class="row rowpadding">
								<label>九级会员价</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="填写九级会员等级享受的会员价"
										v-model.trim="vip_level9_price">
								</div>
							</div>
							<div class="row rowpadding">
								<label>十级会员价</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="填写十级会员等级享受的会员价"
										v-model.trim="vip_level10_price">
								</div>
							</div>
						</div>
					</div>
					<div class="list-other clearfix">
						<h2>其他资料</h2>
						<div class="col-md-6">
							<div class="row rowpadding">
								<label>商品赠送</label>
								<div class="col-md-8 ct-col">
									<select class="form-control" ref="edit_is_present" data-placeholder="商品赠送">
										<option></option>
										<option value="1">是</option>
										<option value="-1">否</option>
									</select>
								</div>
							</div>
							<div class="row rowpadding">
								<label>是否属低消</label>
								<div class="col-md-8 ct-col">
									<select class="form-control" ref="edit_is_min" data-placeholder="是否属低消">
										<option></option>
										<option value="1">是</option>
										<option value="-1">否</option>
									</select>
								</div>
								<span class="rmarkspan" titles="【是】：当前商品的优惠价要抵扣计时开房低消金额<br />【否】：当前商品的优惠价不抵扣计时开房低消金额"
									@mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
							</div>
							<div class="row rowpadding">
								<label>销售套餐</label>
								<div class="col-md-8 ct-col">
									<select class="form-control" ref="edit_is_sale" data-placeholder="销售套餐">
										<option></option>
										<option value="1">是</option>
										<option value="-1">否</option>
									</select>
								</div>
							</div>
							<div class="row rowpadding">
								<label>推荐套餐</label>
								<div class="col-md-8 ct-col">
									<select class="form-control" ref="edit_recommend" data-placeholder="微信巨嗨首页是否推荐">
										<option></option>
										<option value="1">是</option>
										<option value="-1">否</option>
									</select>
								</div>
							</div>
							<div class="row rowpadding">
								<label style="line-height: normal">会员账户可支付设置</label>
								<div class="col-md-8 ct-col">
									<select class="form-control" ref="edit_disc_hz">
										<option value="-1">仅通用账户可支付</option>
										<option value="1">通用账户与赠送账户均可支付</option>
										<option value="2">仅赠送账户可支付</option>
										<option value="3">通用账户与赠送账户均不可支付</option>
									</select>
								</div>
							</div>
							<div class="row rowpadding">
								<label>优惠券是否可用</label>
								<div class="col-md-8 ct-col">
									<select class="form-control" ref="edit_disc_use">
										<option value="1">是</option>
										<option value="-1">否</option>
									</select>
								</div>
								<span class="rmarkspan" titles="【是】该商品套餐在支付时可算入优惠券可用金额。<br/>【否】该商品套餐在支付时金额不算入优惠券可用金额。"
									@mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
							</div>
							<div class="row rowpadding">
								<label>商品是否允许打折</label>
								<div class="col-md-8 ct-col">
									<select class="form-control" ref="edit_is_discount" data-placeholder="是否会员打折">
										<option></option>
										<option value="1">是</option>
										<option value="-1">否</option>
									</select>
								</div>
							</div>
							<div class="row rowpadding">
								<label>服务费收取比例</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="请输入数字，如1，2，3..."
										v-model.trim="edit_service_percent">
								</div>
								<div class="ctr-hint-txt">%</div>
								<span class="rmarkspan" titles="设置为0则不收服务费，设置0以上的数字则在结账时包厢账单按该商品设置的比例收取服务费。"
									@mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
							</div>
							<div class="row rowpadding">
								<label>业绩提成属性:</label>
								<div class="col-md-8 ct-col">
									<select class="form-control" ref="edit_sales_commission">
										<option value="1">计提成计业绩</option>
										<option value="2">无提成计业绩</option>
										<option value="3">无提成无业绩</option>
									</select>
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<div class="row rowpadding">
								<label>消费者端显示</label>
								<div class="col-md-8 ct-col">
									<select class="form-control" ref="edit_is_cshow" data-placeholder="消费者端是否显示">
										<option></option>
										<option value="1">是</option>
										<option value="-1">否</option>
									</select>
								</div>
								<span class="rmarkspan" titles="【是】：在触摸屏，智慧商家app，微信端，支付宝端均显示。<br />【否】：只在智慧商家app端显示。"
									@mouseenter="hint_language($event, 4)" @mouseleave="close_hint_language"></span>
							</div>
							<div class="row rowpadding">
								<label>算订台业绩</label>
								<div class="col-md-8 ct-col">
									<select class="form-control" ref="edit_is_dt" data-placeholder="是否算订台业绩">
										<option></option>
										<option value="1">是</option>
										<option value="-1">否</option>
									</select>
								</div>
								<span class="rmarkspan"
									titles="【是】：商品销售后需要算入订台业绩明细报表和订台业绩汇总报表。<br />【否】：商品销售后不算入订台业绩明细报表和订台业绩汇总报表。"
									@mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
							</div>
							<div class="row rowpadding">
								<label>提成金额</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="请输入商品套餐提成金额" v-model.trim="edit_tc_money"
										ref="edit_tc_money">
								</div>
							</div>
							<div class="row rowpadding">
								<label>提成百分比</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="请输入商品套餐提成百分比"
										v-model.trim="edit_tc_percent" ref="edit_tc_percent">
								</div>
							</div>
							<div class="row rowpadding">
								<label style="line-height: normal">是否适用会员积分抵扣金额</label>
								<div class="col-md-8 ct-col">
									<select class="form-control" ref="edit_disc_hjd">
										<option value="1">是</option>
										<option value="-1">否</option>
									</select>
								</div>
							</div>
							<div class="row rowpadding" v-show="vip_shareholder_status">
								<label>预估成本价</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="请输入预估成本价"
										v-model.trim="edit_forecast_cost">
								</div>
								<span class="rmarkspan" titles="用以计算商品利润的一个数值<br />商品利润=（商品折后价-预估成本价）*毛利"
									@mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
							</div>
							<div class="row rowpadding" v-show="vip_shareholder_status">
								<label>毛利百分比</label>
								<div class="col-md-8">
									<input class="form-control" placeholder="请输入毛利百分比" v-model.trim="edit_gross_ratio">
								</div>
								<div class="ctr-hint-txt">%</div>
								<span class="rmarkspan" titles="用以计算商品利润的一个数值<br />商品利润=（商品折后价-预估成本价）*毛利"
									@mouseenter="hint_language($event, 4)" @mouseleave="close_hint_language"></span>
							</div>
							<div class="row rowpadding">
								<label style="line-height: normal">是否计入可赠送比例</label>
								<div class="col-md-8 ct-col">
									<select class="form-control" ref="edit_give_ratio">
										<option value="1">是</option>
										<option value="-1">否</option>
									</select>
								</div>
								<span class="rmarkspan"
									titles="该套餐是否计入账单消费金额，用于计算赠送金额比例<br/>【是】计入账单消费金额，可用于赠送金额比例<br/>【否】不计入账单消费金额，即不可用于赠送金额比例"
									@mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
							</div>
						</div>
					</div>
					<div class="list-image clearfix">
						<h2>套餐显示图片</h2>
						<div class="col-md-6">
							<h3>商品图片</h3>
							<p>图片尺寸为660*240，大小不超过5M</p>
							<img class="uploadimg defaultimage" :src="submitimg" @click="addImgFun"
								@load="successLoadImg" @error="errorLoadImg">
							<input type="file" class="uploadinput" @change="uploadimgFun($event)" ref="isflies"
								id="isflies" />
							<img src="../../assets/images/vod_del.png" alt="" class="del-icon" v-if="isOnlineImg"
								@click.stop="onDefaultImgDel">
						</div>
						<div class="col-md-6">
							<h3>自助大厅显示图片</h3>
							<p>图片尺寸为2100*1650，如图片尺寸不符合推荐尺寸，会将图片进行拉伸或者压缩</p>
							<img :src="edit_self_img" class="uploadimg" id="editSelfImg">
							<img src="../../assets/images/vod_del.png" alt="" class="del-icon" v-if="isOnlineImg1"
								@click.stop="onSelfImgDel">
						</div>
					</div>
					<div class="list-video clearfix">
						<h2>套餐视频展示<span>（套餐视频仅应用于平板app点单展示，可用视频形式展示商品）</span></h2>
						<h5>视频内容<span
								class="red-txt">该视频格式为mp4，大小不超过5M。视频分辨率建议比例为图片尺寸（660*240）一致，若分辨率不一致，可能存在不满屏播放情况</span>
						</h5>
						<div class="package-video-wrapper" id="package-video-wrapper">
							<img src="../../assets/images/upload_big_txt.png" alt="" v-if="video_url==''">
							<video :src="video_url" controls="" v-else></video>
							<img src="../../assets/images/vod_del.png" alt="" class="del-icon" v-if="video_url!=''"
								@click.stop="onVideoDel">
						</div>
					</div>
					<div class="list-package clearfix">
						<h2>套餐明细</h2>
						<div class="row row-margin">
							<label class="list-label-6">添加套餐商品:</label>
							<div class="col-md-3">
								<button type="button" class="btn bg-orange btn-flat btn-small"
									@click="addCplGoods">添加商品</button>
							</div>
						</div>
						<div class="table-responsive" v-show="showGoodsList">
							<p class="p-hint">显示顺序：app、微信端点单时套餐明细商品显示顺序，1为优先排序</p>
							<table ref="edit_goods_list" class="table table-bordered table-hover"
								data-pagination="true"></table>
						</div>
						<div class="row">
							<button type="button" class="btn btn-flat btn-middle btn-border-gray"
								@click="backList">返回</button>
							<button type="button" class="btn btn-flat btn-middle btn-orange sub-margin"
								@click="saveEdit">提交</button>
						</div>
					</div>
				</div>
				<!-- 商品列表 -->
				<div class="pb-table-alert" ref="cpl_goods_alert">
					<div class="row row-margin">
						<div class="col-md-3 ct-col">
							<select class="form-control" ref="cpl_goods_type" data-placeholder="请选择类型">
								<option></option>
							</select>
						</div>
						<div class="col-md-6">
							<input class="form-control" placeholder="请输入商品名称" v-model="cpl_goods_name"
								@keyup.13="initCplGoods">
						</div>
						<button type="button" class="btn bg-orange btn-flat btn-wide pull-right"
							@click="initCplGoods">查询</button>
					</div>
					<table ref="cpl_goods_list" class="table table-bordered table-hover" data-pagination="true"></table>
				</div>
				<!-- 二维码页 -->
				<div class="list-qrcode" v-show="showQrcode">
					<div class="page-tit">生成商品套餐二维码</div>
					<ul>
						<li>注：</li>
						<li>1，商品二维码可以导出后贴在实物商品商品，消费者可通过微信扫码直接购买该商品</li>
						<li>2，点击鼠标右键图片另存为即可导出</li>
						<li>3，配送包厢：必填是消费者在下单时一定要填写包厢号，禁填是消费者在下单时不能填写包厢号，选填是消费者在下单时可填或者不填包厢号。</li>
					</ul>
					<div class="row">
						<label class="ctr-label-left">门店：</label>
						<div class="col-md-6">
							<span class="list-shop-cg col-md-12">{{list_shop_cg}}</span>
						</div>
					</div>
					<div class="row">
						<label class="ctr-label-left">配送包厢必填：</label>
						<div class="col-md-6 ct-col">
							<select class="form-control" ref="cmdy_qr_box">
								<option value="3">禁填</option>
								<option value="2">选填</option>
								<option value="1">必填</option>
							</select>
						</div>
					</div>
					<div class="row">
						<label class="ctr-label-left">二维码：</label>
						<div class="list-img-wrap col-md-6">
							<img :src="list_qrcode">
						</div>
					</div>
					<div class="row">
						<button type="button" class="btn btn-flat btn-middle btn-border-gray"
							@click="backList">返回</button>
					</div>
				</div>
			</div>



			<div class="cpy-types" v-show="listShow2">
				<div class="types-list">
					<div class="row row-magin-bottom" v-if="types_menu_add">
						<button type="button" class="btn bg-orange btn-flat bigbtn" @click="typesSub(1)">添加类型</button>
					</div>
					<p>注：显示顺序大的在显示端显示靠前</p>
					<div class="table-responsive">
						<table class="table table-bordered table-hover bx-list" data-pagination="true" ref="typesList">
						</table>
						<button type="button" class="btn btn-flat btn-middle btn-border-gray"
							@click="backTit">返回</button>
					</div>
				</div>
				<!-- 添加、修改 -->
				<div class="types-edit" ref="types_edit">
					<div class="row rowpadding">
						<label class="col-md-3">显示顺序:</label>
						<div class="col-md-8">
							<input class="form-control" placeholder="请输入显示顺序，例如01" v-model="types_sort">
						</div>
					</div>
					<div class="row rowpadding">
						<label class="col-md-3">商品套餐类型:</label>
						<div class="col-md-8">
							<input class="form-control" placeholder="请输入商品套餐类型" v-model="types_name">
						</div>
					</div>
					<div class="row rowpadding">
						<label class="col-md-3">消费者端显示:</label>
						<div class="col-md-8 ct-col">
							<select class="form-control" ref="types_custm">
								<option value="1">是</option>
								<option value="-1">否</option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Vue from 'vue';
	export default {
		name: '',
		data() {
			return {
            	vip_shareholder_status: '',
				titShow: true,
				listShow1: false,
				listShow2: false,
				listShow3: false,

				showList: true,
				showEdit: false,
				showQrcode: false,
				list_menu_add: false,
            	list_menu_op: [],
				submitimg: "",
				edit_self_img: require('../../assets/images/uld_btn.png'),
				showSelfImg: true,
				cpl_name: "",
				shop_id: "",
				edit_name: "",
				edit_original_cost: "",
				edit_discount_price: "",
				edit_vip_price: "",
				edit_listorder: '',
				apply_shop: "",
				cpl_goods_name: "",
				selectcomdata: [],
				edit_goods_arr: [],
				showGoodsList: false,
				updateid: "",
				edit_tit: "添加商品套餐",
				error_img: require('../../assets/images/upload.png'),
				list_shop_cg: '',
				list_qrcode: '',
				edit_tc_money: '',
				edit_tc_percent: '',
				vip_level1_price: '',
				vip_level2_price: '',
				vip_level3_price: '',
				vip_level4_price: '',
				vip_level5_price: '',
				vip_level6_price: '',
				vip_level7_price: '',
				vip_level8_price: '',
				vip_level9_price: '',
				vip_level10_price: '',
				serv_rate_num: '',
				edit_service_percent: '',
				edit_bar_code: '',
				edit_forecast_cost: '',
				edit_gross_ratio: '',
				video_url: '',
				uploaderList: [], // 上传插件实例

				// 2222222222222222
				types_menu_add: false,
            	types_menu_op: [],
				types_sort: '',
				types_name: '',

				// 批量修改
				multi_set_form: {
					shop_id: '',
					wares_type: [],
					types_str: '',
					config: {}
				},
				shops: [],
				package_types: [],
				package_type_all: false,
				multi_config: [],
				multi_config_init: [{
	                type: 'select',
	                check: false,
	                label: '是否赠送商品',
	                key: 'is_present',
	                value: '1'
	            }, {
	                type: 'select',
	                check: false,
	                label: '是否消费者端显示',
	                key: 'customer_show',
	                value: '1'
	            }, {
	                type: 'select',
	                check: false,
	                label: '是否允许打折',
	                key: 'discount_status',
	                value: '1'
	            }, {
	                type: 'select',
	                check: false,
	                label: '是否算订台业绩',
	                key: 'outstanding',
	                value: '1'
	            }, {
	                type: 'select',
	                check: false,
	                label: '是否为销售商品',
	                key: 'is_sell',
	                value: '1'
	            }, {
	                type: 'select',
	                check: false,
	                label: '是否为推荐商品',
	                key: 'recommend',
	                value: '-1'
	            }, {
	                type: 'select',
	                check: false,
	                label: '是否属低消',
	                key: 'is_minimum_consumption',
	                value: '1'
	            }, {
	                type: 'select',
	                check: false,
	                label: '是否计入可赠送比例',
	                key: 'included_give_ratio',
	                value: '1'
	            }, {
	                type: 'select',
	                check: false,
	                label: '优惠券是否可用',
	                key: 'use_reward',
	                value: '1'
	            }, {
	                type: 'select',
	                check: false,
					label: '会员账户可支付设置',
	                key: 'vip_present_pay',
	                value: '1'
	            }, {
	                type: 'select',
	                check: false,
	                label: '是否适用会员积分抵扣金额',
	                key: 'vip_points_pay',
	                value: '1'
	            }, {
	                type: 'input',
	                check: false,
	                label: '提成金额',
	                key: 'deduct_amount',
	                value: '',
	                placeholder: '请输入商品提成金额',
	                unit: '元'
	            }, {
	                type: 'input',
	                check: false,
	                label: '提成百分比',
	                key: 'deduct_rate',
	                value: '',
	                placeholder: '请输入商品提成百分比',
	                unit: '%'
	            }, {
	                type: 'input',
	                check: false,
	                label: '服务费收取比例',
	                key: 'service_charge_rate',
	                value: '',
	                placeholder: '请输入服务费收取比例',
	                unit: '%'
	            }, {
	                type: 'input',
	                check: false,
	                label: '预估成本价',
	                key: 'forecast_cost_price',
	                value: '',
	                placeholder: '请输入预估成本价',
	                unit: '元'
	            }, {
	                type: 'input',
	                check: false,
	                label: '毛利百分比',
	                key: 'gross_margin_ratio',
	                value: '',
	                placeholder: '请输入毛利百分比',
	                unit: '%'
	            }, {
	                type: 'select',
	                check: false,
	                label: '业绩提成属性',
	                key: 'sales_commission',
	                value: '1'
	            }],
			}
		},
		computed: {
			menu() {
				let menu = {};
				if(!$.isEmptyObject(this.$store.state.menunew)) {
					menu = JSON.parse(this.$store.state.menunew);
					$.each(menu, function(k, v) {
						if(v.id == '542') {
							menu = v.submenu;
							$.each(menu, function(m, n) {
								if(n.id == '550') {
									menu = n.submenu;
								}
							});
						}
					});
				}
				return menu;
			},
			isOnlineImg() {
	            return this.submitimg.includes("http") 
	        },
	        isOnlineImg1() {
	        	return this.edit_self_img.includes("http")
	        },
		},
		watch: {
			edit_tc_money: {
				handler: function(val, oldVal) {
					if(this.edit_tc_money != '') {
						$(this.$refs.edit_tc_percent).prop('disabled', true);
					} else {
						$(this.$refs.edit_tc_percent).prop('disabled', false);
					}
				},
				deep: true
			},
			edit_tc_percent: {
				handler: function(val, oldVal) {
					if(this.edit_tc_percent != '') {
						$(this.$refs.edit_tc_money).prop('disabled', true);
					} else {
						$(this.$refs.edit_tc_money).prop('disabled', false);
					}
				},
				deep: true
			},
		},
		created: function() {
			this.vip_shareholder_status = this.$store.state.privinfo.vip_shareholder_status
			this.getMenuOp()
		},
		mounted: function() {},
		methods: {
			// 获取权限
			getMenuOp() {
				let _this = this,
					menu = [];
				if(!$.isEmptyObject(this.$store.state.menunew)) {
					menu = JSON.parse(this.$store.state.menunew);
					$.each(menu, function(k, v) {
						if(v.id == '542') {
							menu = v.submenu;
							$.each(menu, function(m, n) {
								if(n.id == '550') {
									menu = n.submenu;
								}
							});
						}
					});

					menu.forEach(items => {
						if(items.id == '874') {
							_this.list_menu_op = [{cls: 'text-blue status', name: '状态'}, {cls: 'text-blue qrcode', name: '二维码'}];
							items.submenu.forEach(_ => {
								if(_.id == '945') {
									_this.list_menu_add = true;
									_this.list_menu_op.push({cls: 'text-blue copy-add', name: '复制新增'});
								}
								if(_.id == '946') {
									_this.list_menu_op.push({cls: 'text-blue edit', name: '修改'});
								}
								if(_.id == '947') {
									_this.list_menu_op.push({cls: 'text-blue del', name: '删除'});
								}
							})
						} else if(items.id == '873') {
							_this.types_menu_op = [];
							items.submenu.forEach(_ => {
								if(_.id == '942') {
									_this.types_menu_add = true;
								}
								if(_.id == '943') {
									_this.types_menu_op.push({cls: 'text-blue edit', name: '修改'});
								}
								if(_.id == '944') {
									_this.types_menu_op.push({cls: 'text-blue del', name: '删除'});
								}
							})
						}
					})
				}
			},
			titClk: function(num) {
				var _this = this;
				_this.titShow = false;
				_this.listShow1 = false;
				_this.listShow2 = false;
				_this.listShow3 = false;

				if(num == '商品套餐列表') {
					_this.getShop();
					$(_this.$refs.cpl_status).select2({
						minimumResultsForSearch: -1,
						language: "zh-CN",
						width: '100%'
					});
					$(_this.$refs.cpl_recommend).select2({
						minimumResultsForSearch: -1,
						allowClear: true,
						language: "zh-CN",
						width: '100%'
					});

					_this.selfImgUpload();
					$(_this.$refs.edit_recommend).select2({
						minimumResultsForSearch: -1,
						allowClear: true,
						language: "zh-CN",
						width: '100%'
					});
					$(_this.$refs.edit_is_discount).select2({
						allowClear: true,
						minimumResultsForSearch: -1,
						language: "zh-CN",
						width: '100%'
					});
					$(_this.$refs.edit_sales_commission).select2({
						allowClear: true,
						minimumResultsForSearch: -1,
						language: "zh-CN",
						width: '100%'
					});
					$(_this.$refs.edit_is_sale).select2({
						allowClear: true,
						minimumResultsForSearch: -1,
						language: "zh-CN",
						width: '100%'
					});
					$(_this.$refs.edit_is_present).select2({
						allowClear: true,
						minimumResultsForSearch: -1,
						language: "zh-CN",
						width: '100%'
					});
					$(_this.$refs.edit_is_min).select2({
						allowClear: true,
						minimumResultsForSearch: -1,
						language: "zh-CN",
						width: '100%'
					});
					$(_this.$refs.edit_is_cshow).select2({
						allowClear: true,
						minimumResultsForSearch: -1,
						language: "zh-CN",
						width: '100%'
					});
					$(_this.$refs.edit_is_dt).select2({
						allowClear: true,
						minimumResultsForSearch: -1,
						language: "zh-CN",
						width: '100%'
					});
					$(_this.$refs.edit_disc_use).select2({
						minimumResultsForSearch: -1,
						language: "zh-CN",
						width: '100%'
					});
					$(_this.$refs.edit_disc_hz).select2({
						minimumResultsForSearch: -1,
						language: "zh-CN",
						width: '100%'
					});
					$(_this.$refs.edit_disc_hjd).select2({
						minimumResultsForSearch: -1,
						language: "zh-CN",
						width: '100%'
					});
					$(_this.$refs.edit_give_ratio).select2({
						minimumResultsForSearch: -1,
						language: "zh-CN",
						width: '100%'
					});
					$(_this.$refs.edit_is_discount).val(-1).trigger("change");
					$(_this.$refs.edit_sales_commission).val(-1).trigger("change");
					$(_this.$refs.edit_is_present).val(-1).trigger("change");
					$(_this.$refs.edit_is_min).val(1).trigger("change");
					$(_this.$refs.edit_is_cshow).val(1).trigger("change");
					_this.getEditGoogstype();

					_this.getGoodsUnit();
					_this.getGoodsType();
					_this.getPackageType();
					_this.listShow1 = true;
				} else if(num == '商品套餐类型') {
					_this.initTypesTable();
					$(_this.$refs.types_custm).select2({
						language: "zh-CN",
						minimumResultsForSearch: -1,
						width: '100%'
					});
					_this.listShow2 = true;
				}
			},
			backTit: function() {
				this.titShow = true;
				this.listShow1 = false;
				this.listShow2 = false;
				this.listShow3 = false;
			},
			// 返回商品列表
			backList: function() {
				this.detPage = false;
				this.qrcodePage = false;
				this.listPage = true;
			},
			// 修改页的提示语
			hint_language: function(e, num) {
				var contents = "<span class='dots'>·</span>" + $(e.currentTarget).attr("titles");
				layer.tips(contents, $(e.currentTarget), {
					skin: 'hint_language_tip',
					tips: [num, '#fff'],
					area: ['400px', ''],
					time: 2000000,
				});
			},
			// 关闭提示语
			close_hint_language: function() {
				layer.closeAll('tips');
			},
			// 获取门店数据
			getShop: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							let arr = [];
							$.each(data['response']['result'], function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.cpl_shop).select2({
								data: arr,
								allowClear: true,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							});
							$(_this.$refs.cpl_shop).val(data.response.result[1].id).trigger('change');
							_this.innitable();

							arr.shift();
							$(_this.$refs.edit_shop).select2({
								data: arr,
								allowClear: true,
								width: '100%'
							}).on("select2:select", function(e) {
								_this.edit_goods_arr = [];
								$(_this.$refs.edit_goods_list).bootstrapTable('destroy');
							});

							let shops = data.response.result
							shops.shift()
							_this.shops = shops
							_this.multi_set_form.shop_id = shops[0].id
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {}
				});
			},
			// 获取商品套餐类型
			getEditGoogstype() {
				const _this = this;

				Vue.axios.post('MerchantGoods/getWareGoodsTypeList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": 0,
							"page_size": 0
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						let arr = [{ id: 0, text: '商品套餐' }];
						$.each(res.data.response.result.rows, function(k, v) {
							arr.push({ id: v.id, text: v.name });
						});

						$(_this.$refs.cpl_goodstype).select2({
							data: arr,
							width: '100%'
						});
						$(_this.$refs.edit_goodstype).select2({
							data: arr,
							width: '100%'
						});
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			innitable: function() {
				let _this = this;

				$(_this.$refs.cpl_list).bootstrapTable('destroy');
				$(_this.$refs.cpl_list).bootstrapTable({
					pageSize: 10,
					pageList: [],
					ajax: function(params) {
						_this.getList(params);
					},
					sidePagination: "server",
					pagination: true,
					columns: [{
						width: "9%",
						field: "shop_name",
						title: "门店"
					}, {
						width: "8%",
						field: "img_url",
						title: "商品套餐<br />图片",
						formatter: function(value, row) {
							var src = "this.src='" + _this.error_img + "'";
							return '<img class="img-size" src="' + value + '" onerror="' + src + '">';
						}
					}, {
						width: "8%",
						field: "goods_type_name",
						title: "商品套餐<br />类型"
					}, {
						width: "8%",
						field: "name",
						title: "商品套餐<br />名称"
					}, {
						width: "8%",
						field: "package_unit_name",
						title: "套餐单位"
					}, {
						width: "8%",
						field: "price",
						title: "原价"
					}, {
						width: "8%",
						field: "actual_price",
						title: "优惠价"
					}, {
						width: "7%",
						field: "status",
						title: "状态",
						formatter: function(value, row) {
							value = value == "-1" ? "禁用" : "启用";
							return value
						}
					}, {
						width: "7%",
						field: "recommend",
						title: "推荐",
						formatter: function(value, row) {
							value = value == "-1" ? "否" : "是";
							return value
						}
					}, {
						width: "19%",
						title: "操作",
						events: {
							'click .edit': function(e, value, row, index) {
								_this.updateid = row.id;
								_this.edit_tit = "修改商品套餐";
								_this.getDet(row.id);
								_this.showList = false;
								_this.showEdit = true;
							},
							'click .qrcode': function(e, value, row, index) {
								_this.list_shop_cg = row.shop_name;
								_this.list_qrcode = row.qrcode_url + '&fill_in_room=3';

								// 配送包厢必填
								$(_this.$refs.cmdy_qr_box).val('').trigger('change');
								$(_this.$refs.cmdy_qr_box).select2({
									width: '100%',
									minimumResultsForSearch: -1,
									language: "zh-CN",
								}).on("select2:select", function(e) {
									_this.list_qrcode = row.qrcode_url + '&fill_in_room='+ e.params.data.id +'';
								});

								_this.showList = false;
								_this.showQrcode = true;
							},
							'click .status': function(e, value, row, index) {
								var statu = row.status == 1 ? -1 : 1;
								_this.deletepackdata(row.id, statu);
							},
							'click .del': function(e, value, row, index) {
								layer.confirm('删除后不可恢复，确定删除吗？', {
									btn: ['确定', '取消']
								}, function() {
									_this.deletepackdata(row.id, -2);
								});
							},
							'click .copy-add': function(e, value, row, index) {
								_this.updateid = '';
								_this.edit_tit = "添加商品套餐";
								_this.getDet(row.id);
								_this.showList = false;
								_this.showEdit = true;
							}
						},
						formatter: function(value, row, index) {
							let statusText = (row.status == 1) ? '禁用' : '启用';
							let op_html = '';
							$.each(_this.list_menu_op, function(k, v) {
								if(v.name == '状态') {
									op_html += '<span class="'+ v.cls +'">'+ statusText +'</span>';
								} else {
									op_html += '<span class="'+ v.cls +'">'+ v.name +'</span>';
								}
							});
							return op_html;
						},
					}],
				});
			},
			getList: function(params) {
				let pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": pageNumber,
							"page_size": "10",
							"shop_id": $(this.$refs.cpl_shop).val(),
							"status": $(this.$refs.cpl_status).val(),
							"recommend": $(this.$refs.cpl_recommend).val(),
							"goods_type": $(this.$refs.cpl_goodstype).val(),
							"name": this.cpl_name
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsPackage",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							params.success({
								total: data['response']['result']['data']['total'],
								rows: data['response']['result']['data']['rows']
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
							params.success({
								total: 0,
								rows: []
							});
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 查询
			queryList: function() {
				this.innitable();
			},
			// 套餐单位
			getGoodsUnit: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"type": "2"
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getGoodsUnit",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							let arr = [];
							$.each(data.response.result.data, function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.edit_unit).select2({
								data: arr,
								allowClear: true,
								language: "zh-CN",
								width: '100%'
							});
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 商品套餐类型
			getGoodsType: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getGoodsType",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							let arr = [{ id: " ", text: "全部" }];
							$.each(data['response']['result']['data'], function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.cpl_goods_type).select2({
								data: arr,
								allowClear: true,
								language: "zh-CN",
								width: '100%'
							});

							arr.shift();
							$(_this.$refs.serv_rate_type).select2({
								data: arr,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 商品套餐类型列表
			getPackageType: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getWaresType",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							_this.package_types = data.response.result.data
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},

			// 商品套餐批量修改弹窗
			multiSet: function() {
				let _this = this;
				_this.multi_config = []
	            _this.multi_config_init.forEach(v => {
	                _this.multi_config.push({...v})
	            })

				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'],
					title: ['商品套餐批量修改', true],
					area: ['600px', '600px'],
					content: $(_this.$refs.multi_set_pop),
					offset: '100px'
				}, function() {
					let config = {}
	                _this.multi_config.forEach(v => {
	                    if(v.check) {
	                        config[v.key] = v.value
	                    }
	                })
					let datas = {
	                    "header": Vue.request_header,
	                    "request": {
	                        "version": Vue.version,
	                        "param": {
	                            "shop_id": _this.multi_set_form.shop_id,
	                            "wares_type": _this.multi_set_form.wares_type,
	                            "config": config
	                        }
	                    },
	                    "comment": ""
	                };
	                let datas2 = JSON.stringify(datas);
	                $.ajax({
	                    type: "post",
	                    dataType: "json",
	                    url: Vue.ctUrl + "WarePackage/batchUpdate",
	                    crossDomain: true,
	                    xhrFields: {
	                        withCredentials: true
	                    },
	                    data: datas2,
	                    success: function(data) {
	                        if(data.response.result_code == "true") {
	                            layer.closeAll();
	                            layer.msg("操作成功");
	                            $(_this.$refs.cpl_list).bootstrapTable("refresh");
	                        } else {
	                            Vue.timeoutfun(data.response.result_status, _this);
	                            layer.msg(data.response.error_msg);
	                        }
	                    },
	                    error: function(err) {
	                        layer.msg("出错啦");
	                    }
	                });
				});
			},

			openPackageTypes() {
				let _this = this;

				let c_wares_type = _this.multi_set_form.wares_type
				let c_package_type_all = _this.package_type_all
				let index = layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'],
					title: ['商品套餐类型', true],
					area: ['550px', ''],
					content: $(_this.$refs.package_type_pop),
					offset: '100px',
					cancel: function() {
						_this.multi_set_form.wares_type = c_wares_type
						_this.package_type_all = c_package_type_all
					}
				}, function() {
					let arr = [];
					_this.multi_set_form.wares_type.forEach(item => {
						_this.package_types.forEach(v => {
							if (v.id == item) {
								arr.push(v.name)
							}
						})
					})
					_this.multi_set_form.types_str = arr.join(',')
					layer.close(index)
				}, function() {
					_this.multi_set_form.wares_type = c_wares_type
					_this.package_type_all = c_package_type_all
				})
			},

			typesAll(val) {
                let ids = [];
				this.package_types.forEach(v => {
					ids.push(v.id);
				});
				this.multi_set_form.wares_type = val ? ids : [];
			},

			typesChange(val) {
				const len = val.length;
				this.package_type_all = len === this.package_types.length;
			},

			// 添加商品套餐
			addCpl: function() {
				this.updateid = "";
				this.edit_tit = "添加商品套餐";
				this.submitimg = "";
				this.edit_self_img = require('../../assets/images/uld_btn.png');
				this.showSelfImg = true;
				this.edit_name = "";
				$(this.$refs.edit_unit).val("").trigger("change");
				$(this.$refs.edit_recommend).val("").trigger("change");
				$(this.$refs.edit_shop).val("").trigger("change");
				$(this.$refs.edit_shop).prop("disabled", false);
				this.edit_original_cost = "";
				this.edit_discount_price = "";
				this.edit_vip_price = "";
				this.edit_listorder = '';
				$(this.$refs.edit_is_discount).val(-1).trigger("change");
				$(this.$refs.edit_sales_commission).val(-1).trigger("change");
				$(this.$refs.edit_is_present).val(-1).trigger("change");
				$(this.$refs.edit_is_sale).val(1).trigger("change");
				$(this.$refs.edit_is_min).val(1).trigger("change");
				$(this.$refs.edit_is_cshow).val(1).trigger("change");
				this.edit_tc_money = '';
				this.edit_tc_percent = '';
				$(this.$refs.edit_is_dt).val('').trigger("change");
				this.edit_service_percent = '';
				$(this.$refs.edit_disc_use).val('').trigger("change");
				$(this.$refs.edit_disc_hz).val('').trigger("change");
				$(this.$refs.edit_goodstype).val("").trigger("change");
				$(this.$refs.edit_disc_hjd).val('').trigger("change");
				$(this.$refs.edit_give_ratio).val('').trigger("change");
				this.edit_forecast_cost = '';
				this.edit_gross_ratio = '';
				this.vip_level1_price = '';
				this.vip_level2_price = '';
				this.vip_level3_price = '';
				this.vip_level4_price = '';
				this.vip_level5_price = '';
				this.vip_level6_price = '';
				this.vip_level7_price = '';
				this.vip_level8_price = '';
				this.vip_level9_price = '';
				this.vip_level10_price = '';
				this.edit_bar_code = '';
				this.edit_goods_arr = [];
				$(this.$refs.edit_goods_list).bootstrapTable('destroy');
				this.showEdit = true;
				this.showList = false;
				this.showGoodsList = false;
				this.video_url = "";
				this.$nextTick(() => {
                	this.videoUpload("package-video-wrapper");
				})
			},
			// 详情
			getDet: function(id) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"id": id
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/getMerchantGoodsPackageDetail",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							let obj = data.response.result.data;
							_this.submitimg = obj.img_url;
							if(obj.hall_img_url == '') {
								_this.edit_self_img = require('../../assets/images/uld_btn.png');
								_this.showSelfImg = true;
							} else {
								_this.edit_self_img = obj.hall_img_url;
								_this.showSelfImg = false;
							}
							_this.edit_name = obj.name;
							$(_this.$refs.edit_unit).val(obj.package_unit).trigger("change");
							$(_this.$refs.edit_recommend).val(obj.recommend).trigger("change");
							$(_this.$refs.edit_shop).val(obj.shop_id).trigger("change");
							$(_this.$refs.edit_shop).prop("disabled", true);
							_this.edit_original_cost = obj.price;
							_this.edit_discount_price = obj.actual_price;
							_this.edit_vip_price = obj.vip_price;
							_this.edit_listorder = obj.listorder;
							$(_this.$refs.edit_is_discount).val(obj.discount_status).trigger("change");
							$(_this.$refs.edit_sales_commission).val(obj.sales_commission).trigger("change");
							$(_this.$refs.edit_is_present).val(obj.is_present).trigger("change");
							$(_this.$refs.edit_is_sale).val(obj.is_sell).trigger("change");
							$(_this.$refs.edit_is_min).val(obj.is_minimum_consumption).trigger("change");
							$(_this.$refs.edit_is_cshow).val(obj.customer_show).trigger("change");
							_this.edit_tc_money = obj.deduct_amount;
							_this.edit_tc_percent = obj.deduct_rate;
							$(_this.$refs.edit_is_dt).val(obj.outstanding).trigger("change");
							_this.edit_service_percent = obj.service_charge_rate;
							_this.edit_forecast_cost = obj.forecast_cost_price;
							_this.edit_gross_ratio = obj.gross_margin_ratio;
							$(_this.$refs.edit_disc_use).val(obj.use_reward).trigger("change");
							$(_this.$refs.edit_disc_hz).val(obj.vip_present_pay).trigger("change");
							$(_this.$refs.edit_goodstype).val(obj.goods_type).trigger("change");
							$(_this.$refs.edit_disc_hjd).val(obj.vip_points_pay).trigger("change");
							$(_this.$refs.edit_give_ratio).val(obj.included_give_ratio).trigger("change");
							_this.vip_level1_price = obj.vip_level1_price;
							_this.vip_level2_price = obj.vip_level2_price;
							_this.vip_level3_price = obj.vip_level3_price;
							_this.vip_level4_price = obj.vip_level4_price;
							_this.vip_level5_price = obj.vip_level5_price;
							_this.vip_level6_price = obj.vip_level6_price;
							_this.vip_level7_price = obj.vip_level7_price;
							_this.vip_level8_price = obj.vip_level8_price;
							_this.vip_level9_price = obj.vip_level9_price;
							_this.vip_level10_price = obj.vip_level10_price;
							_this.edit_bar_code = obj.bar_code;
							_this.edit_goods_arr = obj.goods;
							_this.initEditGoods();
							_this.video_url = obj.video_url;
							_this.$nextTick(() => {
								_this.videoUpload("package-video-wrapper")
							})
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 图片上传
			addImgFun: function() {
				this.$refs.isflies.click();
			},
			uploadimgFun: function(e) {
				var _this = this;
				var file = e.target.files[0];

				// 清除file
				e.target.value = '';
				if(typeof(file) == 'undefined') {
					layer.msg('图片上传失败');
					return false;
				}
				// 压缩图片
				var reader = new FileReader(),
					img = new Image();
				var canvas = document.createElement('canvas');
				var context = canvas.getContext('2d');
				reader.readAsDataURL(file);
				reader.onload = function(e) {
					img.src = e.target.result;
				};
				img.onload = function() {
					// 图片原始尺寸
					var originWidth = this.width;
					var originHeight = this.height;
					// 最大尺寸限制
					var maxWidth = 660, maxHeight = 240;
					// 目标尺寸
					var targetWidth = originWidth, targetHeight = originHeight;
					// 图片尺寸超过限制
					if (originWidth > maxWidth || originHeight > maxHeight) {
						if (originWidth / originHeight > maxWidth / maxHeight) {
							// 更宽，按照宽度限定尺寸
							targetWidth = maxWidth;
							targetHeight = Math.round(maxWidth * (originHeight / originWidth));
						} else {
							targetHeight = maxHeight;
							targetWidth = Math.round(maxHeight * (originWidth / originHeight));
						}
					}
					// canvas对图片进行缩放
					canvas.width = targetWidth;
					canvas.height = targetHeight;
					// 清除画布
					context.clearRect(0, 0, targetWidth, targetHeight);
					// 图片压缩
					context.drawImage(img, 0, 0, targetWidth, targetHeight);
					// canvas转为blob并上传
					var dataurl = canvas.toDataURL('image/png');
					var blob = dataURLtoBlob(dataurl);
					// 创建forme
					var form = new FormData();
					form.append('img', blob, "image.png");
					form.append("upload_path", "ktv_test");
					// 上传
					$.ajax({
						type: "post",
						dataType: "json",
						processData: false,
						contentType: false,
						url: Vue.ctUrl + "Upload/api_uploadPic",
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
						data: form,
						success: function(data) {
							if(data.response.result_code == "true") {
								_this.submitimg = data.response.resault.img_url;
							} else {
								Vue.timeoutfun(data.response.result_status,_this);
								layer.msg("图片上传失败");
							}
						},
						error: function(err) {
							layer.msg("网络原因");
						}
					});
				}
			},
			successLoadImg: function(event) {
				if(event.target.complete == true) {
					event.target.classList.remove("defaultimage");
					var imgParentNode = event.target.parentNode;
					if(imgParentNode.classList.contains('show-img') == true) {
						imgParentNode.style.background = "#000";
					}
				}
			},
			errorLoadImg: function(event) {
				event.target.classList.add("defaultimage");
			},
			onDefaultImgDel: function() {
				this.submitimg = ''
			},
			// 自动大厅图片上传
			selfImgUpload: function() {
				let _this = this;
				let host = '',
					dir = '',
					file_name = '';

				// 实例化一个plupload上传对象
				let uploader = new plupload.Uploader({
					browse_button: 'editSelfImg', // 选择文件id
					filters: {
						// mime_types: [ // 文件格式限制
						// 	{ title: "Image files", extensions: "png" }
						// ],
						// max_file_size: '2mb', // 文件大小限制
						prevent_duplicates: true // 不允许选取重复文件
					},
					resize: {
						width: 2100,
						height: 1650
					},
					multi_selection: false, // 单选
					url: './', // OSS地址
					init: {
						// 文件上传前触发
						BeforeUpload: function(up, file) {
							// 获取签名
							let datas = {
								"header": Vue.request_header,
								"request": {
									"version": Vue.version,
									"param": {
										"file": file.name,
										"path": 'merchantGoods'
									}
								},
								"comment": ""
							};
							let datas2 = JSON.stringify(datas);
							$.ajax({
								type: "POST",
								dataType: "json",
								url: Vue.ctUrl + "publicData/api_getOssSignature",
								async: false,
								crossDomain: true,
								xhrFields: {
									withCredentials: true
								},
								data: datas2,
								success: function(data) {
									if(data['response']['result_code'] == "true") {
										host = data.response.data.host;
										dir = data.response.data.dir;
										file_name = data.response.data.file_name;
										let new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': data.response.data.accessid,
											'policy': data.response.data.policy,
											'signature': data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								},
								error: function(err) {
									layer.msg("出错啦");
								}
							});
						},
						// 文件选择完毕触发
						FilesAdded: function(up, file) {
							// 上传文件
							uploader.start();
						},
						// 文件上传成功触发
						FileUploaded: function(up, file, data) {
							_this.edit_self_img = host + "/" + dir + file_name;
							_this.showSelfImg = false;
							layer.msg('上传成功');
						},
						// 错误提示
						Error: function(up, err) {
							if(err.code == -600) {
								layer.msg('请选择2mb以内的文件');
							} else if (err.code == -601) {
								layer.msg('只允许上传png文件');
							} else if (err.code == -602) {
								layer.msg('这个文件已经上传过一遍了');
							} else {
								layer.msg(err.response);
							}
						}
					}
				});
				// 初始化
				uploader.init();
			},

			onSelfImgDel: function() {
				this.edit_self_img = require('../../assets/images/uld_btn.png')
				this.showSelfImg = true
			},

			// 上传视频
	        videoUpload: function(btnName) {
	        	if (this.uploaderList.length > 0) { // 销毁先前的实例
	        		console.log("destroy", this.uploaderList.length)
	                this.uploaderList.forEach(v => {
	                    v.destroy()
	                })
	            }

	            let _this = this;
	            let host = '',
	                dir = '',
	                file_name = '';

	            setTimeout(function() {
	                // 实例化一个plupload上传对象
	                let uploader = new plupload.Uploader({
	                    browse_button: btnName, // 选择文件id
	                    filters: {
	                        mime_types: [ // 文件格式限制
	                            { title: "video files", extensions: "mp4" }
	                        ],
	                        max_file_size: '5mb', // 文件大小限制
	                        prevent_duplicates: true // 不允许选取重复文件
	                    },
	                    // resize: {
	                    //  width: 527,
	                    //  height: 296
	                    // },
	                    multi_selection: false, // 单选
	                    url: './', // OSS地址
	                    init: {
	                        // 文件上传前触发
	                        BeforeUpload: function(up, file) {},
	                        // 文件选择完毕触发
	                        FilesAdded: function(up, files) {
	                            // 获取签名
	                            Vue.axios.post('publicData/api_getOssSignature', {
	                                "header": Vue.request_header,
	                                "request": {
	                                    "version": Vue.version,
	                                    "param": {
	                                        "file": files[0].name,
	                                        "path": 'Setting'
	                                    }
	                                },
	                                "comment": ""
	                            })
	                            .then(res => {
	                                if(res.data.response.result_code == "true") {
	                                    host = res.data.response.data.host;
	                                    dir = res.data.response.data.dir;
	                                    file_name = res.data.response.data.file_name;
	                                    const new_params = {
	                                        'key': dir + file_name,
	                                        'OSSAccessKeyId': res.data.response.data.accessid,
	                                        'policy': res.data.response.data.policy,
	                                        'signature': res.data.response.data.signature,
	                                        'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
	                                    };
	                                    up.setOption({
	                                        'url': host,
	                                        'multipart_params': new_params
	                                    });

	                                    // 上传文件
	                                    uploader.start();
	                                } else {
	                                    Vue.timeoutfun(data.response.result_status, _this);
	                                    layer.msg(data.response.error_msg);
	                                }
	                            })
	                            .catch(err => {
	                                layer.msg("出错啦");
	                            });
	                        },
	                        // 文件上传成功触发
	                        FileUploaded: function(up, file, data) {
	                            _this.video_url = host + "/" + dir + file_name;
	                            layer.msg('上传成功');
	                        },
	                        // 错误提示
	                        Error: function(up, err) {
	                            if(err.code == -600) {
	                                layer.msg('请选择5mb以内的文件');
	                            } else if (err.code == -601) {
	                                layer.msg('只允许上传mp4文件');
	                            } else if (err.code == -602) {
	                                layer.msg('这个文件已经上传过一遍了');
	                            } else {
	                                layer.msg(err.response);
	                            }
	                        }
	                    }
	                });
	                // 初始化
	                uploader.init();
	                _this.uploaderList.push(uploader)
	            }, 20);
	        },

	        onVideoDel: function () {
	            this.video_url = ''
	        },

			// 添加商品
			addCplGoods: function() {
				let _this = this;

				_this.initCplGoods();
				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'], //按钮
					title: ['添加商品', true],
					area: ['700px', ''], //宽高
					content: $(_this.$refs.cpl_goods_alert),
					offset: '100px'
				}, function() {
					let cpl_goods_list = $(_this.$refs.cpl_goods_list).bootstrapTable('getAllSelections');
					if (cpl_goods_list.length < 1) {
						layer.msg("请选择商品")
						return
					}
					let arr = _this.edit_goods_arr;
					$.each(cpl_goods_list, function(k, v) {
						for(var i = 0; i < arr.length; i++) {
							if(arr[i].id == v.id) {
								layer.msg("商品已存在");
								return;
							}
						}
						v["listorder"] = 1;
						arr.push(v);
					});
					layer.msg('添加成功');
					_this.edit_goods_arr = arr;
					_this.initEditGoods();
				});
			},
			// 商品初始化
			initCplGoods: function() {
				let _this = this;

				$(_this.$refs.cpl_goods_list).bootstrapTable('destroy');
				$(_this.$refs.cpl_goods_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					ajax: function(params) {
						_this.getCplGoods(params);
					},
					sidePagination: "server",
					pagination: true,
					columns: [{
						width: "8%",
						field: "state",
						checkbox: true
					}, {
						width: "25%",
						field: "goods_type_name",
						title: "类型"
					}, {
						width: "25%",
						field: "goods_name",
						title: "名称"
					}, {
						width: "25%",
						field: "goods_unit_name",
						title: "单位"
					}, {
						width: "17%",
						field: "quantity",
						title: "数量",
						events: {
							'blur .quantity': function(e, value, row, index) {
								if(isNaN($(this).val())) {
									layer.msg("请输入数字");
									$(this).val(value);
									return;
								} else if($(this).val() < 1) {
									layer.msg("数量不小于1");
									$(this).val(value);
									return;
								} else if($(this).val().indexOf('.') != '-1') {
									layer.msg("请输入整数");
									$(this).val(value);
									return;
								}
								row.quantity = $(this).val()
							},
							'click .quantity': function(e, value, row, index) {
								e.stopPropagation()
							}
						},
						formatter: function(value, row) {
							return '<input class="quantity" value="' + 1 + '">';
						}
					}, ],
					clickToSelect: true
				});
			},
			getCplGoods: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": pageNumber,
							"page_size": "5",
							"shop_id": $(_this.$refs.edit_shop).val(),
							"status": '1',
							"goods_type": $.trim($(_this.$refs.cpl_goods_type).val()),
							"goods_name": _this.cpl_goods_name,
							// "is_sell": "1"
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							let rows = data.response.result.data.rows
							rows.forEach(item => {
								item.quantity = 1
							})
							params.success({
								total: data['response']['result']['data']['total'],
								rows: rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
							params.success({
								total: 0,
								rows: []
							});
						}
					},
					error: function(err) {}
				});
			},
			// 选中的商品
			initEditGoods: function() {
				let _this = this;

				$(_this.$refs.edit_goods_list).bootstrapTable('destroy');
				$(_this.$refs.edit_goods_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 10,
					pageList: [],
					ajax: function(params) {
						_this.getEditGoods(params);
					},
					sidePagination: "server",
					pagination: false,
					columns: [{
						width: "10%",
						field: "listorder",
						title: "显示顺序",
						events: {
							'blur .listorder': function(e, value, row, index) {
								for(let i = 0; i < _this.edit_goods_arr.length; i++) {
									if(_this.edit_goods_arr[i].id == row.id) {
										_this.edit_goods_arr[i].listorder = $(this).val();
										// _this.initEditGoods();
										return false;
									}
								}
							}
						},
						formatter: function(value, row) {
							return '<input class="listorder" value="' + value + '">';
						}
					}, {
						width: "12%",
						field: "good_img",
						title: "商品图片",
						formatter: function(value, row) {
							var src = "this.src='" + _this.error_img + "'";
							return '<img class="imglogo" src="' + value + '" onerror="' + src + '">';
						}
					}, {
						width: "12%",
						field: "goods_name",
						title: "显示商品名称"
					}, {
						width: "12%",
						field: "goods_type_name",
						title: "商品类型"
					}, {
						width: "12%",
						field: "goods_unit_name",
						title: "商品单位"
					}, {
						width: "15%",
						title: "商品数量",
						field: "quantity",
						events: {
							'keypress .quantity': function(e, value, row, index) {
								if(e.keyCode == "13") {
									$(this).blur();
								}
							},
							'blur .quantity': function(e, value, row, index) {
								let num = $(this).val();
								if(isNaN($(this).val())) {
									layer.msg("请输入数字");
									$(this).val(value);
									return;
								} else if($(this).val() < 1) {
									layer.msg("数量不小于1");
									$(this).val(value);
									return;
								} else if($(this).val().indexOf('.') != '-1') {
									layer.msg("请输入整数");
									$(this).val(value);
									return;
								}
								for(let i = 0; i < _this.edit_goods_arr.length; i++) {
									if(_this.edit_goods_arr[i].id == row.id) {
										_this.edit_goods_arr[i].quantity = $(this).val();
										_this.edit_goods_arr[i].allprice = $(this).val() * _this.edit_goods_arr[i].cost_price;
										_this.initEditGoods();
										return false;
									}
								}
							}
						},
						formatter: function(value) {
							return '<input class="quantity" value="' + value + '">';
						}
					},{
						width: "12%",
						field: "allprice",
						title: "原价金额"
					},{
						width: "12%",
						title: "操作",
						events: {
							'click .adddel': function(e, value, row, index) {
								$.each(_this.edit_goods_arr, function(k, v) {
									if(v.id == row.id) {
										_this.edit_goods_arr.splice(k, 1);
										$(_this.$refs.edit_goods_list).bootstrapTable('refresh');
										return false;
									}
								});
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-blue adddel">删除</span>';
						}
					}],
				});
			},
			getEditGoods: function(params) {
				let _this = this;
				let total = _this.edit_goods_arr.length;
				if(total > 0) {
					_this.showGoodsList = true;
					$.each(_this.edit_goods_arr, function(s, k) {
						k['allprice'] = Vue.accMul(k.quantity, k.cost_price);
					});
				} else {
					_this.showGoodsList = false;
				}
				params.success({
					total: total,
					rows: _this.edit_goods_arr
				});
			},
			// 新增、修改
			saveEdit: function() {
				let _this = this;

				let hall_img_url = '',
					arr = [];
				$.each(_this.edit_goods_arr, function(s, k) {
					arr.push({ merchant_goods_id: k.id, quantity: k.quantity, listorder: k.listorder });
				});
				if(!_this.showSelfImg) {
					hall_img_url = _this.edit_self_img;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"img_url": _this.submitimg,
							"hall_img_url": hall_img_url,
							"name": _this.edit_name,
							"package_unit": $(_this.$refs.edit_unit).val(),
							"recommend": $(_this.$refs.edit_recommend).val(),
							"shop_id": $(_this.$refs.edit_shop).val(),
							"price": _this.edit_original_cost,
							"actual_price": _this.edit_discount_price,
							"vip_price": _this.edit_vip_price,
							"listorder": _this.edit_listorder,
							"discount_status": $(_this.$refs.edit_is_discount).val(),
							"sales_commission": $(_this.$refs.edit_sales_commission).val(),
							"is_present": $(_this.$refs.edit_is_present).val(),
							"is_sell": $(_this.$refs.edit_is_sale).val(),
							"is_minimum_consumption": $(_this.$refs.edit_is_min).val(),
							"customer_show": $(_this.$refs.edit_is_cshow).val(),
							"deduct_amount": _this.edit_tc_money,
							"deduct_rate": _this.edit_tc_percent,
							"outstanding": $(_this.$refs.edit_is_dt).val(),
							"service_charge_rate": _this.edit_service_percent,
							"forecast_cost_price": _this.edit_forecast_cost,
							"gross_margin_ratio": _this.edit_gross_ratio,
							"use_reward": $(_this.$refs.edit_disc_use).val(),
							"vip_present_pay": $(_this.$refs.edit_disc_hz).val(),
							"goods_type": $(_this.$refs.edit_goodstype).val(),
							"vip_points_pay": $(_this.$refs.edit_disc_hjd).val(),
							"included_give_ratio": $(_this.$refs.edit_give_ratio).val(),
							"vip_level1_price": _this.vip_level1_price,
							"vip_level2_price": _this.vip_level2_price,
							"vip_level3_price": _this.vip_level3_price,
							"vip_level4_price": _this.vip_level4_price,
							"vip_level5_price": _this.vip_level5_price,
							"vip_level6_price": _this.vip_level6_price,
							"vip_level7_price": _this.vip_level7_price,
							"vip_level8_price": _this.vip_level8_price,
							"vip_level9_price": _this.vip_level9_price,
							"vip_level10_price": _this.vip_level10_price,
							"bar_code": _this.edit_bar_code,
							"goods": arr,
							"video_url": _this.video_url,
						}
					},
					"comment": ""
				};
				let url = Vue.ctUrl + "merchantGoods/addMerchantGoodsPackage";
				if(_this.updateid != "") {
					datas["request"]["param"]["id"] = _this.updateid;
					url = Vue.ctUrl + "merchantGoods/updateMerchantGoodsPackage";
				}
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: url,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data["response"]["result_code"] == "true") {
							layer.msg(data["response"]["error_msg"]);
							$(_this.$refs.cpl_list).bootstrapTable('refresh');
							_this.showList = true;
							_this.showEdit = false;
						} else {
							layer.msg(data["response"]["error_msg"]);
							Vue.timeoutfun(data.response.result_status,_this);
						}
					},
					error: function(err) {
						layer.msg('网络错误');
					}
				});
			},
			// 禁用、启用、删除
			deletepackdata: function(id, stauts) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"id": id,
							"status": stauts,
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/onOffMerchantGoodsPackage",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							$(_this.$refs.cpl_list).bootstrapTable('refresh');
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
						}
						layer.msg(data["response"]["error_msg"]);
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			backList: function() {
				this.showList = true;
				this.showEdit = false;
            	this.showQrcode = false;
			},

			// 导入商品套餐
			// 点击上传xls文件
	        addXlsFun: function() {
	            this.$refs.xlsFile.click();
	        },
	        // 上传
	        uploadXls: function(e) {
	            let _this = this;

	            let formData = new FormData();
	            formData.append("waresFile", $("#xlsFile")[0].files[0]);
	            // 清除file
	            let obj = document.getElementById('xlsFile');
	            obj.value = '';

	            $.ajax({
	                type: "post",
	                dataType: "json",
	                processData: false,
	                contentType: false,
	                url: Vue.ctUrl + "WarePackage/importData",
	                crossDomain: true,
	                xhrFields: {
	                    withCredentials: true
	                },
	                data: formData,
	                success: function(data) {
	                    if(data.response.result_code == "true") {
	                        layer.msg('导入成功');
	                        $(_this.$refs.cpl_list).bootstrapTable('refresh');
	                    } else {
	                        Vue.timeoutfun(data.response.result_status, _this);
	                        layer.open({
	                            type: 1,
	                            title: '导入失败，数据错误，请修正数据后重新导入！',
	                            skin: 'import-err',
	                            area: ['700px', ''],
	                            content: data.response.error_msg
	                        })
	                    }
	                },
	                error: function(err) {
	                    layer.msg("网络原因");
	                }
	            });
	        },


			// 222222222222222222-------------------------
			// 初始化类型列表
			initTypesTable: function() {
				let _this = this;
				$(_this.$refs.typesList).bootstrapTable('destroy');
				$(_this.$refs.typesList).bootstrapTable({
					pageNumber: 1,
					pageSize: 10,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getTypesList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "sort",
						title: "显示顺序",
						width: "25%"
					}, {
						field: "name",
						title: "商品套餐类型",
						width: "25%"
					}, {
						field: "customer_show",
						title: "消费者端显示",
						width: "25%",
						formatter: function(value, row, index) {
							if(row.customer_show == '1') {
								return '是';
							} else if(row.customer_show == '-1') {
								return '否';
							}
						}
					}, {
						title: "操作",
						width: "25%",
						events: {
							'click .edit': function(e, value, row) {
								_this.typesSub(2, row);
							},
							'click .del': function(e, value, row) {
								_this.deleteTypes(row.id);
							}
						},
						formatter: function(value, row, index) {
							let op_html = '';
							$.each(_this.types_menu_op, function(k, v) {
								op_html += '<span class="'+ v.cls +'">'+ v.name +'</span>&nbsp;&nbsp;';
							});
							return op_html;
						}
					}]
				});
			},
			// 类型数据
			getTypesList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "MerchantGoods/getWareGoodsTypeList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.total,
								rows: data.response.result.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: 0
							});
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 添加、修改商品套餐类型
			typesSub: function(num, row) {
				let _this = this;
				_this.types_sort = '';
				_this.types_name = '';
				$(_this.$refs.types_custm).val('').trigger('change');
				if(num == 2) {
					_this.types_sort = row.sort;
					_this.types_name = row.name;
					$(_this.$refs.types_custm).val(row.customer_show).trigger('change');
				}
				layer.confirm('', {
					skin: 'add_goods-alert',
					type: 1,
					btn: ['确定', '取消'], //按钮
					title: ['商品套餐类型', true],
					area: ['600px', ''], //宽高
					content: $(_this.$refs.types_edit),
					offset: '100px'
				}, function() {
					let datas = {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"sort": _this.types_sort,
								"name": _this.types_name,
								"customer_show": $(_this.$refs.types_custm).val()
							}
						},
						"comment": ""
					};
					let url = '';
					if(num == 1) {
						url = Vue.ctUrl + "MerchantGoods/addWareGoodsType";
					} else if(num == 2) {
						datas["request"]["param"]["id"] = row.id;
						url = Vue.ctUrl + "MerchantGoods/updateWareGoodsType";
					}
					let datas2 = JSON.stringify(datas);
					$.ajax({
						type: "post",
						dataType: "json",
						url: url,
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
						data: datas2,
						success: function(data) {
							if(data.response.result_code == "true") {
								layer.msg(data.response.error_msg);
								$(_this.$refs.typesList).bootstrapTable('refresh');
								layer.closeAll();
							} else {
								Vue.timeoutfun(data.response.result_status, _this);
								layer.msg(data.response.error_msg);
							}
						},
						error: function(err) {
							layer.msg("出错啦");
						}
					});
				});
			},
			// 删除类型
			deleteTypes: function(id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "MerchantGoods/delWareGoodsType",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							if(data.response.result_status == '99') {
								layer.msg(data.response.error_msg);
							} else {
								$(_this.$refs.typesList).bootstrapTable('refresh');
								layer.msg('删除成功');
							}
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
		}
	}
</script>
<style lang="less">
	.cpl-list {
		.pull-right {
			button {
				margin: 0 0 0 30px;
			}
		}
		.bigbtn {
			margin-right: 20px;
			a {
				text-decoration: none;
				color: #fff;
			}
		}
		#xlsFile {
			display: none;
		}
	}
	.cpl-edit {
		h2 {
			margin: 0 0 20px;
			font-size: 20px;
		}
		label {
			float: left;
			width: 120px;
			line-height: 32px;
			font-size: 14px;
			font-weight: normal;
			text-align: right;
		}
		.add-code {
			padding: 20px;
            background: #f5f5f5;
		}
		.list-base {
			padding: 20px;
            margin: 20px 0;
            background: #f5f5f5;
			h3 {
				margin: 0 0 30px;
				font-size: 16px;
				font-weight: normal;
			}
			.edit-vip-hint {
				clear: both;
				padding: 0 0 0 135px;
				color: #F00;
			}
        }
		.list-other {
			padding: 20px;
            background: #f5f5f5;
            .ctr-hint-txt {
                margin: 0 5px 0 0;
            }
        }
		.list-image {
			padding: 20px;
            margin: 20px 0;
            background: #f5f5f5;
			h3 {
				font-size: 16px;
				font-weight: normal;
			}
			p {
				margin: 20px 0;
				color: #F00;
			}
			.uploadimg {
				display: block;
				width: 114px;
				height: 114px;
				cursor: pointer;
			}
			.defaultimage {
				background: url(../../assets/images/uld_btn.png) center no-repeat;
				background-size: 100%;
			}
			.uploadinput {
				display: none;
			}
			.del-icon {
				position: relative;
				z-index: 10;
				margin-top: -245px;
    			margin-left: 100px;
			}
        }
        .list-video {
            padding: 20px 0 20px 20px;
            margin: 20px 0;
            background: #f5f5f5;
            h2 {
                margin: 0 0 20px;
                span {
                    font-size: 14px;
                }
            }
            h5 {
                font-size: 14px;
                .red-txt {
                    color: red;
                    padding-left: 10px;
                } 
            }
            .package-video-wrapper {
                width: 440px;
                height: 160px;
                margin: 20px 0 10px 0;
                cursor: pointer;
                img,
                video {
                    width: 100%;
                    height: 100%;
                }
                .del-icon {
                    position: absolute;
                    top: -15px;
                    right: -25px;
                    width: 33px;
                    height: 33px;
                }
            }
        }
		.list-package {
			padding: 20px;
            background: #f5f5f5;
        }
		.editableinput {
			width: 76% !important;
		}
		.ctr-hint-txt {
			margin: 0 15px 0 0;
		}
		.listorder {
			width: 100px;
			padding: 8px 12px;
			border: 1px solid #ccc;
		}
	}
	.pb-table-alert {
		display: none;
		div {
			padding-left: 0;
		}
	}


	.shopul li {
		position: relative;
		display: block;
		width: 50%;
		float: left;
	}

	.queryrow {
		padding-left: 0;
		margin-left: -16px;
	}

	#employee_name {
		border-left: none;
	}

	.add_goods-alert .layui-layer-wrap {
		padding: 20px;
	}
	.img-size {
		display: block;
		width: 90px;
		height: 50px;
	}
	.editableinput-focus {
		border: 1px solid #CCC;
		background: #FFF;
	}
	.list-qrcode {
		ul {
			margin: 0 0 36px;
			color: #F00;
		}
		.list-shop-cg {
			padding: 0 12px;
			line-height: 32px;
			font-size: 14px;
			background: #EEE;
			border: 1px solid #AAA;
		}
		.list-img-wrap {
			border: 1px solid #AAA;
			padding: 20px 0;
			margin: 0 15px 30px;
			img {
				display: block;
				width: 337px;
				margin: 0 auto;
			}
		}
	}


	.cpy-types {
        .types-list {
            p {
                line-height: 50px;
                color: #F00;
                margin: 0;
            }
        }
        .types-edit {
            display: none;
            width: 70%;
			margin: 0 auto;
			label {
				padding: 0;
				line-height: 32px;
				color: #5e5e5e;
				font-size: 14px;
				text-align: right;
				font-weight: 400;
			}
        }
    }

    .multi-set-pop {
    	.el-select,
    	.el-input {
    		width: 300px;
    	}
    	.red-tip {
    		margin-bottom: 20px;
    		color: red;
    	}
    	.row {
            clear: both;
            margin: 0 0 20px;
        }
        .el-checkbox {
            float: left;
            margin-top: 10px;
        }
        .el-form-item__label {
            width: 124px;
            text-align: left;
        }
        .beyond {
            line-height: 20px;
        }
        .el-input {
            width: 300px;
        }
        .el-input__inner {
            height: 40px!important;
        }
    }
    .package-type-pop {
    	.multi {
    		border: 1px solid #e5e5e5;
    	}
    	.all {
    		padding-left: 25px;
		    border-bottom: 1px solid #e5e5e5;
		    line-height: 32px;
		    background: #f5f5f5;
    	}
    	.group {
    		padding: 10px 0 10px 25px;
    	}
    	.el-checkbox {
    		width: 120px;
    		margin: 10px 10px 0 0;
    	}
    }
</style>